import type { MiddlewareFunction, Params } from 'react-router';

import { isMemberLoggedIn } from '@trello/authentication';

/**
 * Logged In Redirect Middleware Factory
 *
 * This middleware redirects logged-in users to a specified URL.
 * Useful for pages that should only be accessible to logged-out users
 *
 * @param createRedirectUrl The function that creates the redirect URL from route params.
 * @returns The React Router middleware function.
 */
export const createLoggedInRedirect =
  (
    createRedirectUrl?: (params: Readonly<Params<string>>) => string,
  ): MiddlewareFunction =>
  async ({ params }): Promise<Response | void> => {
    if (isMemberLoggedIn()) {
      const url = createRedirectUrl ? createRedirectUrl(params) : '/home';

      window.location.assign(url);

      // Return a response to stop further processing of the route
      return new Response(null, {
        status: 302,
      });
    }
  };
